<template>
  <div class="d-flex" dir="rtl" style="height: 100dh;">
    <div class="chat-list">
      <ChatList :messages="messages" @selectChat="selectChat"/>
    </div>
    <div class="chat-view">
      <ChatView :chat="chat" :messages="messages" />
    </div>
    <div v-if="showInfoSideBar" class="info-side-bar">
      <InfoSideBar :chat="chat"/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ChatList from '@/views/ChatList.vue';
import ChatView from '@/views/ChatView.vue';
import InfoSideBar from '@/views/InfoSideBar.vue';

import axios from 'axios';

export default {
  name: 'HomeView',
  components: {
    ChatList,
    ChatView,
    InfoSideBar
  },
  data(){
    return {
      messages: [],
      chat: {},
      showInfoSideBar: false,
      showChatList: true,
      showChatView: false
    }
  },
  async mounted() {
    // console.log(process.env.API_ENDPIONT)
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        this.$router.push({ name: 'login' });
        return;
      }

      const response = await axios.get('https://api.noticapp.ir/v1/messages', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      this.messages = response.data.data;

      this.messages.forEach((message) => {
        if (message.status === 'sent') {
          axios.patch(`https://api.noticapp.ir/v1/messages/${message.id}`, {
            status: 'received',
          }, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .catch(error => {
            console.error(`Error marking message ${message.id} as received: `, error);
          })
        }
      })

      if (response.data.status === 'error') {
        this.$router.push({ name: 'login' });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        this.$router.push({ name: 'login' });
      } else {
        console.error('خطای ناشناخنه رخ داده است: ', error);
      }
    }

    const chatBackIcon = this.$el.querySelector(".chat-back-icon");
    chatBackIcon.addEventListener("click", () => {
    const chatList = document.querySelector('.chat-list');
    chatList.style.display = 'flex';
    const chatView = document.querySelector('.chat-view');
    chatView.style.display = 'none';
    this.showInfoSideBar = false
    })
  },
  beforeCreate() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/login');
    }
  },
  methods: {
    selectChat(chat) {
      if (window.innerWidth < 1024 && window.innerWidth > 760) {
        const chatList = document.querySelector('.chat-list');
        chatList.style.display = 'block';
        const chatView = document.querySelector('.chat-view');
        chatView.style.display = 'block';
      } else if (window.innerWidth < 760) {
        const chatList = document.querySelector('.chat-list');
        chatList.style.display = 'none';
        const chatView = document.querySelector('.chat-view');
        chatView.style.display = 'block';
      } else {
        const chatList = document.querySelector('.chat-list');
        chatList.style.display = 'block';
        const chatView = document.querySelector('.chat-view');
        chatView.style.display = 'block';
        this.showInfoSideBar = true
      }
      const chatTop = document.querySelector('#chat-top');
      chatTop.style.display = 'flex';
      this.chat = chat;
    }
  }
}
</script>

<style>
  .chat-list {
    width: 600px;
  }

  .chat-view {
    width: 100%;
    position: relative;
  }

  .float-btn {
    position: absolute;
    bottom: 20px;
    left: 20px; /* انتقال به سمت چپ داخل بخش چت */
    background-color: #028D92;
    color: white;
    border: none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    z-index: 1000;
    font-size: 24px;
  }
  .float-btn:hover {
    background-color: #2c8c91;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  }
  .float-btn:active {
    background-color: #0b3232 !important;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  }

  .info-side-bar {
    width: 600px;
  }

  /* mobile */
  @media (max-width: 760px) {
    .chat-list {
      width: 100%;
    }

    .chat-view {
      display: none;
    }

    .info-side-bar {
      display: none;
    }

    .float-btn {
      bottom: 120px;
    }
  }

  @media (760px < width < 1024px) {
    .chat-list {
      width: 300px;
    }

    .info-side-bar {
      display: none;
    }
  }
</style>
